var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServicesFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Service") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/ServicesFill",
    fill: "#6C7DBC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,2.2738781 C17.3688193,2.2738781 21.7261219,6.63118071 21.7261219,12 C21.7261219,16.2960508 18.9361556,19.9444308 15.0704565,21.2309064 C14.7641578,21.3328404 14.4511053,21.4199458 14.132152,21.49137 L14.1309482,15.9813424 C15.7973295,15.1834992 16.9688461,13.4868201 16.9688461,11.5073611 C16.9688461,9.26532079 15.4640533,7.37675531 13.4239986,6.77079847 L13.4239986,11 C13.4239986,11.5522847 12.9762833,12 12.4239986,12 L11.5760014,12 C11.0237167,12 10.5760014,11.5522847 10.5760014,11 L10.5760014,6.77079847 C8.52584747,7.38685459 7.03115393,9.26532079 7.03115393,11.5073611 C7.03115393,13.4868201 8.20267049,15.1834992 9.86905179,15.9813424 L9.8688781,21.4898781 L9.5660964,21.4186853 C5.46306892,20.3602841 2.40628721,16.6893011 2.2780688,12.2880539 L2.2738781,12 C2.2738781,6.63118071 6.63118071,2.2738781 12,2.2738781 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesFill);
export default __webpack_public_path__ + "static/media/ServicesFill.870aa3e0402f5f2b824259367a4217f0.svg";
export { ForwardRef as ReactComponent };